import { ChangeDetectionStrategy, Component, computed, input, output, Signal, signal } from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'

import { OVERFLOW_MENU_SOURCE, OverflowMenuItem, type OverflowMenuSource } from '../responsive-content/responsive-overflow-menu-source'
import { type TimeUnit } from '../../interactions/interaction-interface'

export interface GroupByOption {
	readonly value: TimeUnit
	readonly icon: string
	readonly label: string
}

@Component({
	selector: 'app-group-by-menu',
	imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
	templateUrl: './group-by-menu.html',
	styleUrl: './group-by-menu.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{ provide: OVERFLOW_MENU_SOURCE, useExisting: GroupByMenu },
	],
})
export class GroupByMenu implements OverflowMenuSource {
	/** The currently selected grouping option. */
	readonly groupBy = input<TimeUnit>('month', { alias: 'group-by' })

	/** Grouping options for the menu. */
	readonly options = input<GroupByOption[]>([], { alias: 'options' })

	/** Emits the selected grouping option. */
	readonly groupingSelected = output<TimeUnit>({ alias: 'grouping-selected' })

	readonly menuLabel = signal('Group By').asReadonly()
	readonly menuIcon = signal('group').asReadonly()

	readonly menuItems: Signal<OverflowMenuItem[]> = computed(() =>
		this.options()
			.filter(option => this.groupBy() !== option.value)
			.map(({ value, icon, label }) => ({ label, icon, run: () => this.groupingSelected.emit(value) })),
	)

}
